import { ApiApplication } from './shared'

export const mapApplication = ({
  app_id: appId,
  archived: archived,
  assess: assess,
  assessPending: assessPending,
  code: code,
  code_shorthand: codeShorthand,
  created: created,
  first_seen: firstSeen,
  importance: importance,
  importance_description: importanceDescription,
  language: language,
  last_reset: lastReset,
  last_seen: lastSeen,
  master: master,
  missingRequiredFields: missingRequiredFields,
  name: name,
  notes: notes,
  override_url: overrideUrl,
  path: path,
  policies: policies,
  protect: protect,
  roles: roles,
  short_name: shortName,
  size: size,
  size_shorthand: sizeShorthand,
  status: status,
  tags: tags,
  techs: techs,
  total_modules: totalModules
}: ApiApplication) => ({
  appId,
  archived,
  assess,
  assessPending,
  code,
  codeShorthand,
  created,
  firstSeen,
  importance,
  importanceDescription,
  language,
  lastReset,
  lastSeen,
  master,
  missingRequiredFields,
  name,
  notes,
  overrideUrl,
  path,
  policies,
  protect,
  roles,
  shortName,
  size,
  sizeShorthand,
  status,
  tags,
  techs,
  totalModules
})
